import * as t from 'io-ts'
import { BallotState, __BallotState } from './ballot-state'

/**
 * MunicipalityId is a newtype around 'Int'. Unlike with cantons, we do not
 * check whether this Int is part of the allowed municipalities at runtime.
 */
interface MunicipalityIdBrand {
  readonly MunicipalityId: unique symbol
}
export const MunicipalityId = t.intersection([
  t.Int,
  t.brand(t.number, (x): x is t.Branded<number, MunicipalityIdBrand> => x >= 0, 'MunicipalityId'),
])
export type MunicipalityId = t.TypeOf<typeof MunicipalityId>

/**
 * Return the MunicipalityId value as a number
 */
export const unMunicipalityId = (x: MunicipalityId): number => x

/**
 * Create a new MunicipalityId from a number. If the input is not an Int and not
 * positive, a warning is printed to the console.
 */
export const mkMunicipalityId = (x: number): MunicipalityId => {
  if (!MunicipalityId.is(x)) {
    console.warn(`mkMunicipalityId: invalid MunicipalityId "${x}"`)
  }
  return x as MunicipalityId
}

export const mkMunicipalityIdFromString = (str: string): MunicipalityId => {
  const x = parseInt(str, 10)
  if (!MunicipalityId.is(x)) {
    console.warn(`mkMunicipalityId: invalid MunicipalityId "${x}"`)
  }
  return x as MunicipalityId
}

/**
 * MunicipalityState collects information about a canton.
 */
export interface MunicipalityState {
  id: MunicipalityId
  name: string
  ballotState: BallotState
}

export const __MunicipalityState = {
  default: [
    { id: mkMunicipalityId(261), name: 'Zürich', ballotState: __BallotState.finalResult.yea },
  ] as Array<MunicipalityState>,
}
